import AutoResizablePanel from "../AutoResizablePanel/AutoResizablePanel";
import { Outputs } from "./components/Outputs";
import { GenPreviewBloc } from "./GenPreviewBloc";
import { Footer } from "./components/Footer";
import { Logo } from "./components/Logo";
import styles from "./index.module.scss";

type GenPreviewProps = {
  bloc: GenPreviewBloc;
};

export function GenPreview(props: GenPreviewProps) {
  if (props.bloc.visible.value === false) {
    return null;
  }

  return (
    <AutoResizablePanel position="top-right" className={styles.nodePreviewPane} data-testid="genPreviewPane">
      <div className={styles.previewPane}>
        <div className={styles.previewLayout}>
          <div className={styles.saasContent}>
            <Logo />
            <Outputs bloc={props.bloc} />
          </div>
          <Footer bloc={props.bloc} />
        </div>
      </div>
    </AutoResizablePanel>
  );
}
